import { QueryObserverResult, useQuery } from '@tanstack/react-query';
import { APIClient } from 'api/APIClient';
import { QueryKeys } from 'constants/queryKeys';
import { ActivityLogs } from 'api/types/types';

async function getActivityLogs(id: string | null): Promise<ActivityLogs[]> {
  const { data } = await APIClient().get(`request/${id}/activitylogs`);
  return data;
}

export function useActivityLogsQuery(
  id: string | null
): QueryObserverResult<ActivityLogs, unknown> {
  return useQuery({
    queryKey: [QueryKeys.ACTIVITY_LOGS, id],
    queryFn: () => getActivityLogs(id),
    refetchOnMount: false,
    enabled: !!id,
    retry: false,
    meta: {
      errorMessage: 'Ekki tókst að sækja aðgerðarsögu. Reyndu aftur síðar',
    },
  });
}
